import { ProcessingScheduleInfo } from 'state/inventoryScheduleUpdateWorkflows';
import AppConstants from 'constants/AppConstants';

// Add processing schedule data
export function addProcessingSchedule(info: ProcessingScheduleInfo): BaseTockAction {
  return {
    type: AppConstants.BUSINESS_INVENTORY_SCHEDULES_PROCESSING_ADD,
    payload: info,
  };
}

export function updateProcessingSchedule(info: ProcessingScheduleInfo): BaseTockAction {
  return {
    type: AppConstants.BUSINESS_INVENTORY_SCHEDULES_PROCESSING_UPDATE,
    payload: info,
  };
}

// Remove from the array of currently processing schedule data
export function removeProcessingSchedule(scheduleId: number): BaseTockAction {
  return {
    type: AppConstants.BUSINESS_INVENTORY_SCHEDULES_PROCESSING_REMOVE,
    payload: scheduleId,
  };
}
